<template>
    <div id="app">
        <v-dialog v-model="blockDialog" persistent width="400px">
            <v-card style="height: 100px">
                <v-progress-linear style="margin: 0px" height="20" indeterminate color="primary"></v-progress-linear>
                <p style="font-size: 20px; padding: 15px; margin: 0px">{{ $t('Загрузка') }}...</p>
            </v-card>
        </v-dialog>
        <v-app>
            <v-content>
                <v-container class="ma-0 pa-0" fluid>
                    <v-layout fill-height>
                        <v-flex>
                            <TheToolbar
                                :title="$t('АлматыЭнергоСбыт Online. Приём заявок')"
                                v-bind:menuItems="menuItems"
                                :applyRequestBtnText="isROESUser || isRESUser ? 'Зарегистрировать заявку' : 'Подать заявку'"
                            >
                                <template v-slot:locale>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-btn flat v-on="on">{{ $t('Сменить язык') }}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-tile
                                                v-for="(lang, index) in langs"
                                                :key="index"
                                                @click="onChangeLocale(lang)"
                                                :disabled="$i18n.locale == lang.id"
                                            >
                                                <v-list-tile-action class="check-action">
                                                    <v-btn icon ripple v-if="$i18n.locale == lang.id">
                                                        <v-icon color="primary">mdi-check</v-icon>
                                                    </v-btn>
                                                </v-list-tile-action>
                                                <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </TheToolbar>
                        </v-flex>
                        <!-- <v-flex>
                            <input type="text" id="ku" style="font-size: 20px" value="User is inactive = false" />
                        </v-flex> -->
                    </v-layout>
                </v-container>
                <v-container class="ma-0 pa-0" fluid>
                    <v-layout fill-height>
                        <v-flex>
                            <v-fade-transition mode="out-in">
                                <router-view />
                            </v-fade-transition>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </v-app>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TheToolbar from './components/TheToolbar';
import { cloneArray } from './utility/routines';

import { LocaleService } from './services/storage.service';

import { INACTIVE_USER_TIME_THRESHOLD, USER_ACTIVITY_THROTTLER_TIME } from './config/consts';
import { UserService, AuthenticationError } from './services/user.service';

export default {
    name: 'App',
    components: { TheToolbar },
    data() {
        return {
            langs: [
                { id: 'kz', name: 'Қазақша' },
                { id: 'ru', name: 'Русский' }
            ],
            blockDialog: true
        };
    },
    computed: {
        //        ...mapGetters('toolbar', ['filtredMenuItems'])
        ...mapState('toolbar', ['menuItems']),
        ...mapGetters('user', ['isROESUser', 'isRESUser'])
    },
    methods: {
        onChangeLocale(locale) {
            this.$i18n.locale = locale.id;
            LocaleService.setLocale(locale.id);
            window.location.reload(true);
        }
    },
    async created() {
        LocaleService.setLocale(this.$i18n.locale);
        let menuItems = this.$router.options.routes.filter(item => {
            if (item.meta && item.meta.showInMainMenu) {
                return true;
            }
        });
        // кланируем массив через JSON-серилизацию, чтоб сделалились именно копии объектов
        // иначе 2 разных массива будут хранить в себе ссылки на одни и те же объекты
        menuItems = cloneArray(menuItems);
        await this.$store.dispatch('user/loadUserData');
        await this.$store.dispatch('toolbar/initMenuItems', menuItems);
        this.blockDialog = false;
    }
};

let userActivityTimeout = null;
let userActivityThrottlerTimeout = null;
let isInactive = false;

//activateActivityTracker();

function activateActivityTracker() {
    window.addEventListener('mousemove', userActivityThrottler);
    window.addEventListener('scroll', userActivityThrottler);
    window.addEventListener('keydown', userActivityThrottler);
    window.addEventListener('resize', userActivityThrottler);
    window.addEventListener('beforeunload', deactivateActivityTracker);
}

function deactivateActivityTracker() {
    window.removeEventListener('mousemove', userActivityThrottler);
    window.removeEventListener('scroll', userActivityThrottler);
    window.removeEventListener('keydown', userActivityThrottler);
    window.removeEventListener('resize', userActivityThrottler);
    window.removeEventListener('beforeunload', deactivateActivityTracker);
}

function resetUserActivityTimeout() {
    clearTimeout(userActivityTimeout);

    userActivityTimeout = setTimeout(() => {
        userActivityThrottler();
        inactiveUserAction();
    }, INACTIVE_USER_TIME_THRESHOLD);
}

function userActivityThrottler() {
    if (isInactive) {
        isInactive = false;
        //document.getElementById('ku').value = 'User is inactive = false';
    }
    resetUserActivityTimeout();

    // if (!userActivityThrottlerTimeout) {
    //     userActivityThrottlerTimeout = setTimeout(() => {
    //         resetUserActivityTimeout();
    //         clearTimeout(userActivityThrottlerTimeout);
    //     }, USER_ACTIVITY_THROTTLER_TIME);
    // }
}

function inactiveUserAction() {
    isInactive = true;
    //document.getElementById('ku').value = 'User is inactive = true';

    //UserService.logout();
    //window.location.reload();
}
</script>
<style>
.check-action {
    min-width: 35px !important;
}
</style>
